function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4135 5.86207C10.4135 5.44828 10.1031 5.03448 9.58589 5.03448C9.17209 5.03448 8.7583 5.34483 8.7583 5.86207V11.2414C8.7583 11.4483 8.86175 11.6552 8.9652 11.7586L11.7583 14.5517C12.0686 14.8621 12.5859 14.8621 12.8962 14.5517C13.2066 14.2414 13.2066 13.7241 12.8962 13.4138L10.4135 10.931V5.86207Z",
  fill: "#AAB6D3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
  stroke: "#AAB6D3",
  strokeWidth: 1.4,
  strokeMiterlimit: 10
});

var SvgClockNew = function SvgClockNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock_new.ba555212.svg";
export { ForwardRef as ReactComponent };